import { render } from "./index.vue?vue&type=template&id=79e5605b&bindings={}"
import script from "./Actions.js?vue&type=script&lang=js"
export * from "./Actions.js?vue&type=script&lang=js"

import "./Actions.scss?vue&type=style&index=0&lang=scss"
script.render = render

export default script